export default __webpack_public_path__ + "static/media/doctor.5c34098a.png";